const utils = require('../../lib/utils')
module.exports = {
	config: {
		// NOTE: overwrite config flags use-case dependent
		// listComponentClass: 'base_mediaManagement_image_imageList',
		// listElementComponentClass: 'base_form_media_image_image',
		// listNewElementContainerClass: '.newImageList',
		// nrOfElementsComponentClass: 'base_mediaManagement_image_nrOfElements',
		// getCategorizedMediaActionName: 'getCategorizedMedia'
	},

	model: {
		nrOfElements: {
			nrOfSelectedElements: 0,
			nrOfShownElements: 0,
			nrOfMatchingElements: 0,
			nrOfElements: 0
		}
	},

	methods: {
		dataDealer: function(){
			// NOTE: this function has to be overwritten by use-case ancestor and should be used to defined configs
			// this.model.fieldConfig = this.getResourceRegisterContent('fieldConfig') || {}
			// this.model.managementConfig = this.model.fieldConfig.managementConfig || {}
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this
			var media = self.model.mediaListComponent.getSelectedMedia()
			var nrOfElements
			// no media selected
			if(!media || (nrOfElements = utils.collectionSize(media)) <= 0){
				return self.performAction(self.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:imageManagement.delete.noImagesSelected'
					}
				}))
			}

			var messageBaseName = 'hint.delete.really.media'
			if(nrOfElements > 1) messageBaseName = 'hint.delete.really.mediaMultiple'
			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__(messageBaseName + '.title'),
					message:    storage.__(messageBaseName + '.message', { nrOfElements: nrOfElements })
				}
			).then(function(context){
				if(context.decision.type === 'yes'){
					var deletionPromises = []
					var mediaIndex
					for(mediaIndex in media){
						deletionPromises.push(
							self.performAction(
								self.prepareAction('deleteMedia', media[mediaIndex].mediaID)
							)
						)
					}

					return utils.promise.performAll(self, deletionPromises).then(function(context){
						var selectors = []
						for(mediaIndex in media){
							if(self.model.mediaListComponent){
								self.model.mediaListComponent.model.selectedMedia[media[mediaIndex].mediaID] = -1
								delete self.model.mediaListComponent.model.mediaList['mediaID_' + media[mediaIndex].mediaID]
							}
							selectors.push('.' + self.config.listElementComponentClass + '[data-media-id="' + media[mediaIndex].mediaID + '"]')
						}
						self.$.find(selectors.join(',')).remove()
						if(self.$.find(self.config.listNewElementContainerClass).find('.' + self.config.listElementComponentClass + '[data-media-id]:not(.deleted)').length === 0){
							self.$.find(self.config.listNewElementContainerClass).removeClass('active')
						}
						if(self.model.mediaListComponent){
							self.model.mediaListComponent.updateNrOfElements()
						}
					})
				}
			})
		},

		download: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var mediaID = (additionalData || {}).mediaID
			var mediaList = ((((actionBossComponent || {}).model || {}).mediaListComponent || {}).model || {}).mediaList || {}
			var media
			if(mediaID && (media = mediaList[`mediaID_${mediaID}`])){
				window.open(media.url, '_blank').focus()
			}
		},

		copyToClipboardUrl: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var mediaID = (additionalData || {}).mediaID
			var mediaList = ((((actionBossComponent || {}).model || {}).mediaListComponent || {}).model || {}).mediaList || {}
			var media
			if(mediaID && (media = mediaList[`mediaID_${mediaID}`])){
				utils.copyToClipboard(media.url)
			}
		},

		showAssign: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this
			if(buttonContext === 'tags'){
				var mediaID = (additionalData || {}).mediaID
				var media
				// single media assignment (inclusive preselected categories)
				if(mediaID){
					media = self.model.mediaListComponent.getMediaByID(mediaID)
					self.openTagAssignment([mediaID], media.tagsResources, 'showTagAssignmentMediaEnhanced', media)
				}
				// multi media assignment (exclusive preselected categories)
				else {
					media = self.model.mediaListComponent.getSelectedMedia()
					// no media selected
					if(!media || utils.collectionSize(media) <= 0){
						return self.performAction(self.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:imageManagement.showAssign.tags.noImagesSelected'
							}
						}))
					} else {
						var mediaIDs = []
						utils.forEach(media,function(media){
							mediaIDs.push(media.mediaID)
						})
						if(mediaIDs.length <= 0){
							return self.performAction(self.prepareAction('message', undefined, {
								messageDisplay: {
									message: 'error:imageManagement.showAssign.tags.noMediaIDsFound'
								}
							}))
						} else {
							return self.openTagAssignment(mediaIDs)
						}
					}
				}
			}

			return utils.promise.reject()
		},

		selectAll: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.model.mediaListComponent.selectAllMedia()
		},

		deselectAll: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.model.mediaListComponent.deselectAllMedia()
		},

		openTagAssignment: function(mediaIDs, cmsEntitiesCategories, overrideAction, media){
			var self = this
			self.model.assignTagsToMedia = {
				mediaIDs,
				cmsEntitiesCategories
			}
			self.model.tagPickerButton.open((cmsEntitiesCategories || {}).data || [], function(options){
				// submit tag assigments
				self.onTagsPicked(options)
				// submit image details if necessary
				if(options.enhancementComponent && (options.decisionOptions || {}).decisionType !== 'cancel'){
					options.enhancementComponent.submit()
				}
			}, overrideAction, media)
		},

		onTagsPicked: function(options){
			var self = this
			var dirtyAssignedTags, dat, media, mediaID, mediaIDs, mediaIndex
			var tagsToUpdate = []
			if(
				(dirtyAssignedTags = ((options || {}).decisionOptions || {}).dirtyAssignedTags || {})
				&&
				(media = self.model.assignTagsToMedia || {})
				&&
				(mediaIDs = media.mediaIDs)
			){
				for(mediaIndex in mediaIDs){
					for(dat in dirtyAssignedTags){
						tagsToUpdate.push({
							type: dirtyAssignedTags[dat].type === 'delete' ? 'delete' : undefined,
							attributes: {
								entityCategoryID: 	dirtyAssignedTags[dat].entityCategoryID || dirtyAssignedTags[dat].id,

								entityID: 			mediaIDs[mediaIndex],
								entityType: 		options.categoryEntityType,
								categoryID: 		dirtyAssignedTags[dat].categoryID,
								categoryDataID: 	dirtyAssignedTags[dat].categoryDataID,
								enabled: 			dirtyAssignedTags[dat].enabled
							}
						})
					}
				}
			}

			if(tagsToUpdate.length > 0){
				self.performAction(
					self.prepareAction('updateTagAssignments', undefined, undefined, {
						source: {
							submit: {
								data: {
									data: tagsToUpdate
								}
							}
						}
					})
				).then(function(){
					return self.updateMediaTagsInList(mediaIDs).then(function(){
						var statusController
						if((statusController = getComponent('statusController'))) {
							statusController.addPanel('status.done.assigned')
						}
					})
				})
			} else {
				// silent update of media-tags (tag trl could be changed)
				self.updateMediaTagsInList(mediaIDs)
			}
		},

		updateMediaTagsInList: function(mediaIDs){
			var self = this
			if(utils.collectionSize(mediaIDs) > 0){
				return self.performAction(
					self.prepareAction(self.config.getCategorizedMediaActionName, undefined, undefined, {
						source: {
							load: {
								resourceFilters: {
									listOfMediaIDs: mediaIDs
								}
							}
						}
					})
				).then(function(context){
					self.model.mediaListComponent.updateMediaTagsByMediaID((((context || {}).action || {}).response || {}).data || [])
					return utils.promise.resolve()
				})
			}

			return utils.promise.reject()
		},

		initComponentReferences(){
			if(
				this.model.mediaListComponent &&
				this.model.nrOfElementsComponent &&
				this.model.tagPickerButton
			){
				return
			}

			if(!this.model.mediaListComponent){
				this.find(this.config.listComponentClass, mediaListComponent => {
					this.model.mediaListComponent = mediaListComponent
				})
			}
			if(!this.model.nrOfElementsComponent && this.config.nrOfElementsComponentClass){
				this.find(this.config.nrOfElementsComponentClass, nrOfElementsComponent => {
					this.model.nrOfElementsComponent = nrOfElementsComponent
					this.model.nrOfElementsComponent.updateNrOfElements(this.model.nrOfElements)
				})
			}

			if(!this.model.tagPickerButton){
				this.find('base_form_fields_tag-picker-button', tagPickerButton => {
					this.model.tagPickerButton = tagPickerButton
				})
			}
		},
	},

	hooks: {
		attach(){
			this.initComponentReferences()
		},
		postAttach($element, options){
			this.initComponentReferences()
		},

		updateMediaTagsInList($element, options){
			this.updateMediaTagsInList(options.mediaIDs)
		},

		filterChanged($element, options){
			this.initComponentReferences()

			if(this.model.mediaListComponent) this.model.mediaListComponent.updateFilters(options.filters || {})
		},

		showMediaDetails($element, options){
			this.triggerFind('showMediaDetails', options)
		},

		updateNrOfElements($element, options){
			this.initComponentReferences()

			this.model.nrOfElements = options.nrOfElements
			if(this.model.nrOfElementsComponent){
				this.model.nrOfElementsComponent.updateNrOfElements(options.nrOfElements)
			}
		},
	}
}